// extracted by mini-css-extract-plugin
export default {"container":"MainMenu_container_aPLGd","item":"MainMenu_item_E67sN","icon":"MainMenu_icon_ws0r9"};